<template>
    <div class="my-corp-view">
      <div class="content1">
        <div class="corp-name">方寸科技</div>
      </div>
      <div class="content2">上海方寸信息科技有限公司成立于2011年8月，基于对全球移动互联网行业的趋势把握，凭借敏锐的市场触觉、 丰富的互联网运作经验和雄厚的资金支持，致力于成为中国移动互联网应用开发和运营的领军者。</div>
      <div class="content3">公司拥有专业的研发技术团队、资深的游戏开发经验、广泛的平台推广资源，以应对市场上层出不穷的需求。基于敏锐的市场触觉、 强大的开发实力上海方寸已经陆续推出《怪物x联盟》、《喵将传》，《魔天记>等受到大众喜爱的优质游戏产品。</div>
    </div>
</template>

<script>
export default {
  name: 'mycorp'
}
</script>

<style scoped>
  .my-corp-view{
    width: 100%;
    flex-grow: 1;
    background: url("../assets/mycorp.jpg") no-repeat fixed top;
    background-size: cover;
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    display: flex;
    position: relative;
  }
  .content1{
    margin-top: 15%;
    margin-left: 10%;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }
  .corp-name{
    font-size:3.13rem;
    font-weight:bold;
    line-height:4.13rem;
    color:rgba(255,255,255,1);
    flex-shrink: 0;
  }
  .corp-build-time{
    margin-left: 1rem;
    width:19.31rem;
    height:3.19rem;
    font-size:2.44rem;
    font-weight:400;
    line-height:3.19rem;
    color:rgba(255,255,255,1);
  }
  .content2{
    margin-top: 1%;
    margin-left: 10%;
    width: 50%;
    font-size:2rem;
    line-height:3.19rem;
    color:rgba(255,255,255,1);
  }
  .content3{
    margin-top: 1%;
    margin-left: 10%;
    width: 50%;
    font-size:2rem;
    line-height:3.19rem;
    color:rgba(255,255,255,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/mycorp.vue